// extracted by mini-css-extract-plugin
export default {"root":"aFMwrrpsS1Fe13wQAtmX1"};